import CourseMapSummary from './CourseMapSummary';
export default CourseMapSummary;
